module.exports = __webpack_public_path__ + "files/SPIADI2019 - Présentation PHW.2b04beef5273f5846928fbf09031a876.pdf";